import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import mcpSetupMd from '/doc/mcp-setup.md?url&raw'
import { copyCodeComponents } from '../components/help/CopyCodeBlock.jsx'
import { PAGE_STANDARD } from '../lib/layout.js'

export default function McpSetupPage() {
  return (
    <main className={`${PAGE_STANDARD} pb-12 pt-8 sm:pt-12`}>
      <article className="prose prose-slate prose-sm max-w-none sm:prose-base">
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={copyCodeComponents}>
          {mcpSetupMd}
        </ReactMarkdown>
      </article>
    </main>
  )
}
